import React, { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";
import { Track } from "types/track";

export const useTracks = () => {
  const [tracks, setTracks] = React.useState<Track[]>([]);
  const [fetching, setFetching] = React.useState(true);
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

  useEffect(() => {
    (async () => {
      try {
        setFetching(true);
        const response = await axios.get(
          `${API_BASE_URL}${API_URLS.Tracks}`,
          { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
        );
        setTracks(response.data.data);
      } catch (e) {
        console.error(e);
      } finally {
        setFetching(false);
      }
    })();
  }, []);
  return { tracks, fetching };
};
